import React from 'react'
import { Route, Redirect } from 'react-router-dom'

const GuardedRoute = ({ component: Component, role, roles = [
  "IVR_USER",
  "IVR_FACILITATOR"
], ...rest }) => {
  let _user = JSON.parse(localStorage.getItem('user'))
  const user = _user?.user



  return (
    <Route
      {...rest}
      render={(props) => {
        // let roles = [
        //   "IVR_USER",
        //   "IVR_FACILITATOR"
        // ]
        if (role) {
          roles = roles.filter(r => r == role)
        }
        if (user) {
          if (roles.includes(user.role)) {
            return <Component {...props} />
          }
          if (user.role === 'IVR_ADMIN') {
            return <Redirect to="/admin" />
          }
        }
        return <Redirect to="/login" />
      }
      }
    />
  )
}

export default GuardedRoute